module.exports = __webpack_public_path__ + "static/media/normal.8de94988.jpg";